import type { RiskPrivateView } from "@frontier/content/risk";
import type {
  ShipSnapshot,
} from "@frontier/protocol/contracts";

export function currentRisk(
  view: RiskPrivateView | null,
  runId: string | undefined,
): RiskPrivateView | null {
  return view?.runId === runId ? view : null;
}
export function deathMessage(
  view: RiskPrivateView | null,
  pilot: Pick<ShipSnapshot, "dead" | "pending">,
): string | null {
  if (
    pilot.dead &&
    (!view?.state.dead || !view.state.lastLoss || pilot.pending)
  )
    return "Подтверждаем восстановление и состояние груза…";
  const loss = view?.state.lastLoss;
  if (!loss)
    return pilot.dead ? "Подтверждаем восстановление и состояние груза…" : null;
  const special = loss.lost.filter((kind) => kind === "contraband").length;
  const details = loss.lost.length
    ? `Потеряно: ${loss.lost.length}${special ? `, контрабанда: ${special}` : ""}. Сохранено: ${loss.retained}. ${loss.dropped ? `Выпало контейнеров: ${loss.dropped}.` : "Потерянный груз уничтожен."}`
    : loss.retained > 0 ? `Груз сохранён: ${loss.retained}.` : "Трюм был пуст.";
  const wallet = loss.walletLoss ? ` Убийце передано: ${BigInt(loss.walletLoss.credits).toLocaleString("ru-RU")} КР и ${loss.walletLoss.components} комп.` : "";
  return `${pilot.dead ? "Корабль восстанавливается. " : "Последняя гибель. "}${details}${wallet}`;
}

